//jslint sloppy: true
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  // ---------------------------------------------------------------------------
  // TEMPORARY: Find Venue switching view modes (showing/hiding containers)
  $('.find-venue-util--viewmode a').on('click', function (e) {
    e.preventDefault();
    $('.find-venue-results-wrapper').hide();
    $('.find-venue-results-wrapper.' + $(this).data('class')).show();
    $('.find-venue-results-wrapper.' + $(this).data('class') + ' .slider-simple').slick('setPosition');
    $('.find-venue-util--viewmode a').removeClass('active');
    $(this).addClass('active');
  });
  $('.find-venue-results-wrapper.view-gallery').hide();
  // REMOVE ^ TEMPORARY IN FINAL IMPLEMENTATION
  // ---------------------------------------------------------------------------


  // ---------------------------------------------------------------------------
  // Venue Search - Find Venue results page
  Northstar.venueSearch = {
    attach: function () {
      //console.log('Northstar.venueSearch loaded');

      // List View - set map height to vh - collapsed navbar
      if ($('.find-venue-results-wrapper.view-list').length) {
        $(window).on('scroll', function () {
          requestAnimationFrame(Northstar.venueSearch.stickyMaps);
        });
        $(window).on('load resize', function () {
          Northstar.venueSearch.setMapHeight();
          requestAnimationFrame(Northstar.venueSearch.stickyMaps);
        });
      }

      // Toggling the full map display
      $('.find-venue-util--viewmode a').on('click', Northstar.venueSearch.resizeMap);

    },

    setMapHeight: function (min) {
        //do not set map Height for map view
        if ($('.find-venue-results-wrapper .venue-card').length) {          
            //var navHeight = Northstar.menu.getFxdmenuH(),  windowHeight = $(window).height();
            //$('.find-venue-results-wrapper.view-list .find-venue-map > div').css({ height: (windowHeight - navHeight) });
        } else {            
            $($('.find-venue-results-wrapper .find-venue-map > div')[0]).css('height', '');
        }
	},

    resizeMap: function (e) {
      var display = $(this).data('view');
      if (typeof display != 'undefined' && display == 'map') {
        $('.find-venue-results-wrapper.view-list').addClass('fullsize-map');
      }
      else if (typeof display != 'undefined' && display == 'list') {
        if ($('.find-venue-results-wrapper.view-list').hasClass('fullsize-map')) {
          $('.find-venue-results-wrapper.view-list').removeClass('fullsize-map');
          // Rebuild sliders
          $('.slider-simple').slick('unslick');
          Northstar.gallery.create($('.slider-simple'), Northstar.gallery.opt.simple);
        }
      }
      $(window).resize();
    },

    stickyMaps: function (e) {
      var map = $('.find-venue-results-wrapper.view-list .find-venue-map > div').eq(0),
        view = $('.find-venue-util--viewmode .active').data('view');
      if ($('.find-venue-results-wrapper.view-list').css('display') != 'none') {
        if (typeof view != 'undefined' && view == 'map') {
         // Northstar.sticky.sticky(map, 0, true);
        }
        else {
          Northstar.venueSearch.setMapHeight();
          //Northstar.sticky.sticky(map, 0);
        }
      }
    }
  };
  // Initialize our app on document ready
  $(document).ready(Northstar.venueSearch.attach);


  // ---------------------------------------------------------------------------
  // Venue Previews - Find Venue results page
  Northstar.venuePreviews = {
    attach: function () {
      // console.log('Northstar.venuePreviews loaded');

      // Venue Previews, load, close, reposition
      $('.venue-preview').on('click', Northstar.venuePreviews.open);
      $('body').on('click', Northstar.venuePreviews.close);
      $(window).on('load resize', function () {
        requestAnimationFrame(Northstar.venuePreviews.position);
      });
      $('#addToCollectionModal').on('show.bs.modal', Northstar.venuePreviews.close);
    },

    position: function () {
      if ($('.venue-card.preview:visible').length) {
        $('.venue-card.preview:visible').css('marginLeft', '');
        var preview = $('.venue-card.preview:visible'),
          left = preview.offset().left,
          width = $(window).width(),
          previewW = preview.outerWidth(),
          previewL = parseFloat(preview.css('marginLeft'));
        if (left < 15) {
          preview.css('marginLeft', previewL + -1*(left) + 15);
        }
        if (left + previewW > width - 15) {
          preview.css('marginLeft', previewL - ((left + previewW) - (width - 15)));
        }
        Northstar.global.scrollTo(preview, -15);
      }
    },

    close: function (e) {
      $('.find-venue-results').removeClass('disabled');
      $('.venue-card.preview').hide();
    },

    open: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var venuecard = $(this).closest('.venue-card'),
        preview = $('.venue-card.preview', venuecard),
        slider = $('.slick-slider', venuecard),
        opts = Northstar.gallery.opt.simple;

      // Update opts
      opts.initialSlide = slider.slick('slickCurrentSlide');

      // Existing preview, show
      if (preview.length) {
        preview.show();
        $('.slider-simple', preview).slick('unslick');
      }
      else {
        // Need to destroy the slider before we copy it
        slider.slick('unslick');
        preview = venuecard.clone();
        Northstar.gallery.create(slider, opts);
        venuecard.append(preview.addClass('preview'));
        preview.on('click', function (e) {
          e.stopPropagation();
        });
      }

      // Rebuild slick
      Northstar.gallery.create($('.slider-simple', preview), opts);

      // Overlay & position
      $('.find-venue-results').addClass('disabled');
      Northstar.venuePreviews.position();
    }
  };
  // Initialize our app on document ready
  $(document).ready(Northstar.venuePreviews.attach);

}(jQuery, this, this.document));
